import React from 'react';

const LogoPlaceholder: React.FC<{ name: string }> = ({ name }) => {
  const initials = name
    .split(' ')
    .map(word => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  return (
    <div className="logo-placeholder">
      {initials}
    </div>
  );
};

export default LogoPlaceholder; 